import React, { useState } from 'react';

import DataSelect from '../common/DataSelect';
import { useGetTeamsQuery } from '../../redux/services/teamApi';

const SelectTeamInput = ({
  label = 'Team',
  ...props
}) => {
  // const [search, setSearch] = useState('');
  console.log('SelectTeamInput props', props);
  return (
    <DataSelect
      useGetQuery={useGetTeamsQuery}
      label={props?.hideLabel ? null : label}
      {...props}
    />
  );
};

export default SelectTeamInput;